import React from "react";
import { Route, Routes } from "react-router-dom";
import User from "../Pages/User";
import SignIn from "../Pages/SignIn";
import Notfound from "../Pages/Notfound";
import Home from "../Pages/Home";
import PrivateRoute from "./PrivateRoute";
import Cropcount from "../Pages/Cropcount";

function AllRoutes() {
    return (
        <>
            {/* <Navbar/> */}
            <Routes>
                <Route path="/login" element={<SignIn />}></Route>
                <Route path="/" element={ <PrivateRoute><Cropcount /></PrivateRoute> }></Route>
                <Route path="/dashboard" element={ <PrivateRoute><Home /></PrivateRoute> }></Route>
                <Route path="/manage-users" element={ <PrivateRoute><User /></PrivateRoute> }></Route>
                <Route path="*" element={<Notfound />}></Route>
            </Routes>
        </>
    );
}

export default AllRoutes;
